import * as React from 'react';
import { useSelector } from 'react-redux';

import { IApplicationState } from '../../../store/models';
import { Footer } from './Footer';
import { Header } from './Header';

import './index.scss';

export const Layout: React.FC = ({ children }) => {
    const isFooterVisible = useSelector<IApplicationState, boolean>((state) => state.layout.foooter.isVisible);

    return (
        <>
            <div className="layout">
                <Header />
                <div className="application-body">
                    {children}
                </div>
                {isFooterVisible && <Footer />}
            </div>
        </>
    );
};
